import { authAPI } from 'src/core/api/axios';

export const validateMfaProcedureWithSca = async (
  mfaToken: string,
  scaToken: string,
  validateTrustedDevice = false,
): Promise<void> => {
  await authAPI.post(
    '/sca/validate-procedure-with-mfa',
    { token: mfaToken, validateTrustedDevice },
    { headers: { Authorization: `Bearer ${scaToken}` } },
  );
};
